"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PICKUP_ORDER_TYPE = exports.RECEPTION_ORDER_TYPE = undefined;

var _keys = require("babel-runtime/core-js/object/keys");

var _keys2 = _interopRequireDefault(_keys);

exports.getCurrentVoucher = getCurrentVoucher;
exports.priceWithoutVAT = priceWithoutVAT;
exports.vatAmount = vatAmount;
exports.priceWithVAT = priceWithVAT;
exports.totalPriceWithVAT = totalPriceWithVAT;
exports.getItemCount = getItemCount;
exports.getNumbers = getNumbers;
exports.createBuyerName = createBuyerName;
exports.getOrderType = getOrderType;
exports.switchOrderType = switchOrderType;
exports.showValueOnTrue = showValueOnTrue;

var _NumberUtil = require("./NumberUtil");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getCurrentVoucher(vouchers, params) {
  if (!params) {
    return null;
  }
  var orderId = params.orderId,
      voucherId = params.voucherId,
      token = params.token;


  if (token) {
    return vouchers.find(function (voucher) {
      return voucher.id === parseInt(voucherId, 10);
    }) || null;
  }

  return vouchers.find(function (voucher) {
    return voucher.id === parseInt(voucherId, 10) && voucher.order_id === parseInt(orderId, 10);
  }) || null;
}

function priceWithoutVAT(voucher) {
  return (0, _NumberUtil.formatPrice)(voucher.price / 125.5 * 100);
}

function vatAmount(voucher) {
  return (0, _NumberUtil.formatPrice)(voucher.price / 125.5 * 25.5);
}

function priceWithVAT(voucher) {
  return (0, _NumberUtil.formatPrice)(voucher.price);
}

function totalPriceWithVAT(voucher) {
  return (0, _NumberUtil.formatPrice)(voucher.price * voucher.quantity);
}

function getItemCount(voucher) {
  return voucher.quantity;
}

function getNumbers(voucher) {
  var quantity = voucher.quantity;
  var firstId = voucher.first_voucher_id;
  var lastId = voucher.first_voucher_id + quantity - 1;
  return quantity === 1 ? "" + firstId : firstId + " - " + lastId;
}

function createBuyerName(voucher) {
  if (voucher.order_company_name) {
    return voucher.order_company_name + " - " + voucher.order_first_name + " " + voucher.order_last_name;
  }
  return voucher.order_first_name + " " + voucher.order_last_name;
}

var RECEPTION_ORDER_TYPE = exports.RECEPTION_ORDER_TYPE = "reception";
var PICKUP_ORDER_TYPE = exports.PICKUP_ORDER_TYPE = "pickup";

var orderTypePath = {
  "/lipukekauppa": RECEPTION_ORDER_TYPE,
  "/lipukekauppa-nouto": PICKUP_ORDER_TYPE
};

var pathOrderType = (0, _keys2.default)(orderTypePath).reduce(function (a, k) {
  a[orderTypePath[k]] = k;return a;
}, {});

function getOrderType(_ref) {
  var pathname = _ref.pathname;

  return orderTypePath[pathname.match(/^.[\-a-zA-Z]*/g)[0]];
}

function switchOrderType(_ref2) {
  var orderType = _ref2.orderType,
      pushRoute = _ref2.pushRoute;

  if (pathOrderType[orderType]) {
    pushRoute(pathOrderType[orderType]);
  }
}

function showValueOnTrue(conditional, value) {
  conditional ? value : "";
}


/*****************
 ** WEBPACK FOOTER
 ** ./src/utils/VoucherUtil.js
 ** module id = 23
 ** module chunks = 0
 **/